import React, { useEffect, useState } from 'react';
import Wizard from '@/components/atoms/Wizard';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Text } from '@/components/atoms/Text';
import RawModal from '@/components/atoms/RawModal';
import { computeText } from '@/locales/utils';
import { getUserToken } from '@/redux/user';
import { StepContainer } from './DeletePickupPointModal.style';
import { useDeletePickupPointMutation } from '@/services/innovorder/pickupPoint/pickupPoint.endpoints';
import WarnShiftDelete from './WarnShiftDelete';
import { DeletePickupPointModalProps } from './DeletePickupPointModal.type';

export const ORDER_START_TIME = 8;
export const ORDER_END_TIME_TIME = 14;

export const DeletePickupPointModal: React.FunctionComponent<React.PropsWithChildren<DeletePickupPointModalProps>> = ({
    onHide,
    pickupPointId,
    name = '',
    isOpen,
}) => {
    const intl = useIntl();
    const token = useSelector(getUserToken);
    const [deletePickupPoint, { isLoading: isDeleteLoading, isSuccess: isDeleteSuccess }] =
        useDeletePickupPointMutation();
    const [pickupPointName, setPickupPointName] = useState(name);

    const hour = new Date().getHours();
    const isCriticalShiftTime = hour >= ORDER_START_TIME && hour < ORDER_END_TIME_TIME;

    useEffect(() => {
        setPickupPointName(name);
    }, [name, setPickupPointName]);

    useEffect(() => {
        if (isDeleteSuccess) {
            onHide();
            window.location.reload();
        }
    }, [isDeleteSuccess, onHide]);

    return isCriticalShiftTime ? (
        <WarnShiftDelete />
    ) : (
        <RawModal isOpen={isOpen} onHide={onHide}>
            <Wizard
                width={480}
                steps={[
                    {
                        title: 'pickupPoint.modal.delete.title',
                        onCancel: onHide,
                        component: (
                            <StepContainer>
                                <Text
                                    type="normal"
                                    weight="regular"
                                    text={computeText(intl, 'pickupPoint.modal.delete.description', {
                                        name: pickupPointName ?? '',
                                    })}
                                />
                            </StepContainer>
                        ),
                    },
                ]}
                isLoading={isDeleteLoading}
                onValidate={() => {
                    if (pickupPointId) {
                        deletePickupPoint({ pickupPointId, token: token || '' });
                    }
                }}
            />
        </RawModal>
    );
};
